import apiController from "@/utils/apiController";
import { carregaTarifasCustoLinha } from "@/utils/custoLinhaContrato";
import { buildTracadoAnteriorPayload, nowSqlDatetime } from "@/utils/historicoAlteracoesRotas";

/**
 * Baseline do histórico de alterações de uma rota editada no CRUD de Linhas.
 * Usa o ORIGINAL/CALCULADA/TRACADO_ANTERIOR que a rota já tiver; sem nenhum, grava o
 * traçado de antes da edição (`anterior`, de snapshotTracadoRota) como TRACADO_ANTERIOR e
 * devolve esse registro. Sem baseline e sem traçado anterior, devolve null.
 */
export async function resolveBaselineCrud({ idRota, anterior, linha, idUsuario }) {
  const baselineRes = await apiController.request(
    apiController.endpoints.getBaselinehistoricoalteracoesrotas,
    { query: { id_rota: idRota, todas_bases: 1 }, silent: true },
  );
  const baseline = baselineRes && baselineRes.data;
  if (baseline && baseline.id_grupo) return baseline;
  if (!anterior) return null;

  // Tarifas da linha: as edições seguintes do grupo são custeadas com os mesmos parâmetros
  let params = null;
  try {
    params = await carregaTarifasCustoLinha(linha, null);
  } catch (e) {
    params = null;
  }
  const l = linha || {};
  const payload = buildTracadoAnteriorPayload({
    anterior: {
      ...anterior,
      id_empresa: anterior.id_empresa != null ? anterior.id_empresa : l.id_empresa,
      id_cliente: anterior.id_cliente != null ? anterior.id_cliente : l.id_cliente,
    },
    idUsuario,
    dtEvento: nowSqlDatetime(),
    idLinha: l.id_linha != null ? l.id_linha : null,
    params: params
      ? { fixedCost: params.fixedCost, costPerKm: params.costPerKm, laborCost: params.laborCost }
      : null,
  });
  const res = await apiController.request(
    apiController.endpoints.insertHistoricoalteracoesrotas,
    { data: { ...payload, id_usuario: idUsuario }, silent: true },
  );
  const inserted = res && res.data;
  if (!inserted || inserted.id_historico_alteracao_rota == null) return null;
  return { ...payload, id_historico_alteracao_rota: inserted.id_historico_alteracao_rota };
}
